export default __webpack_public_path__ + "static/media/maximize.bd09c596.svg";